import React from "react";

import { withStyles } from "@material-ui/core/styles";

const styles = {
  link: {
    textDecoration: "none",
  },
  icon: {
    width: "0.5em",
    paddingLeft: 2,
  },
};

const UrlRef = ({ record = {}, source, classes }) => {
  const myLink = `${record[source]}`;
  return (
    <a href={myLink} className={classes.link} target="_blank">
      {myLink}
    </a>
  );
};

export default withStyles(styles)(UrlRef);



// WEBPACK FOOTER //
// ./src/UrlRef.js